import React, { forwardRef } from 'react';
import ModalDialog, { useModal } from '@atlaskit/modal-dialog';
import { InvitePeopleWithAnalytics } from '../InvitePeople';
import { type InvitePeopleModalProps } from '../../types';

const InvitePeopleModalBody = forwardRef((props: any, ref: any) => {
	return (
		<div
			{...props}
			style={{
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
				padding: '0px',
			}}
			ref={ref}
		/>
	);
});

const InvitePeopleModalWithTitleId = ({
	onCloseHandler,
	...invitePeopleProps
}: InvitePeopleModalProps) => {
	const { titleId } = useModal();
	return (
		<InvitePeopleModalBody aria-describedby="invite-people-form-description">
			{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
			<div onClick={preventDialogClose}>
				<InvitePeopleWithAnalytics
					onSendHandler={() => onCloseHandler('invite')}
					onCancelHandler={() => onCloseHandler('cancel')}
					titleId={titleId}
					{...invitePeopleProps}
					viewAs={'modal'}
				/>
			</div>
		</InvitePeopleModalBody>
	);
};

const preventDialogClose = (event: React.MouseEvent<HTMLDivElement>) => {
	event.stopPropagation();
};

export const InvitePeopleModal = ({
	onCloseHandler,
	...invitePeopleProps
}: InvitePeopleModalProps) => {
	return (
		<ModalDialog
			width="small"
			onClose={() => onCloseHandler('blur')}
			shouldScrollInViewport
			testId={'invite-people-modal'}
		>
			<InvitePeopleModalWithTitleId onCloseHandler={onCloseHandler} {...invitePeopleProps} />
		</ModalDialog>
	);
};

export default InvitePeopleModal;
